import { hashKey, useQuery } from '@tanstack/react-query';
import {
  fetchNotasAguardandoRecebimento,
  type NotasAguardandoRecebimentoFiltro,
} from '../api/NotasAguardandoRecebimentoApi';

/**
 * O aviso das notas aguardando no Recebimento (SPEC-018, §3, item 8); só consulta com período escolhido.
 * `aplicacao` muda a cada "Buscar" e "Limpar filtros": com a mesma empresa e o mesmo período, o aviso recarrega junto
 * com a lista e continua na tela enquanto recarrega, em vez de sumir e voltar. Com outra empresa ou outro período, o
 * número anterior não vale e não é mostrado.
 */
export function useNotasAguardandoRecebimento(
  filtro: NotasAguardandoRecebimentoFiltro | null,
  aplicacao = 0
) {
  return useQuery({
    queryKey: ['notas-aguardando-recebimento', filtro, aplicacao],
    queryFn: () => fetchNotasAguardandoRecebimento(filtro as NotasAguardandoRecebimentoFiltro),
    enabled: !!filtro,
    staleTime: 60_000,
    placeholderData: (anterior, consultaAnterior) =>
      consultaAnterior && hashKey([consultaAnterior.queryKey[1]]) === hashKey([filtro])
        ? anterior
        : undefined,
  });
}
